module.exports = __webpack_public_path__ + "static/media/4c417620-8cb3-4a35-a9b1-9f8e246c1b6c.e79a7e74.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/4c417620-8cb3-4a35-a9b1-9f8e246c1b6c.jpg
// module id = 817
// module chunks = 0